import { render, staticRenderFns } from "./editDept.vue?vue&type=template&id=45b5307c&"
import script from "./editDept.vue?vue&type=script&lang=js&"
export * from "./editDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports